/**
 * Created by piotr.pozniak@thebeaverhead.com on 13/10/2018.
 */

import React, { useEffect } from "react";
import { ReactNotifications } from "react-notifications-component";

import { BrowserRouter, useHistory, useLocation } from "react-router-dom";

import AxiosConfig from "../../AxiosConfig";
import useDidMountEffect from "../../hooks/useDidMountEffect";
import MainRoutesComponent from "./MainRoutesComponent";
import ModalRoutesComponent from "./ModalRoutesComponent";
import { useAppStore } from "../../hooks/redux/app";
import { useUserStore } from "../../hooks/redux/user";
import { useAutologinStore } from "../../hooks/redux/autologin";
import { useCurrentOrganizationStore } from "../../hooks/redux/currentOrganization";
import appConfig from "../../appConfig";
import OrgSwitchOverlay from "./component/OrgSwitchOverlay";
import { useAppTagStore } from "../../hooks/redux/appTags";
import GraceInfoModal from "./component/Subscription/GraceInfoModal";
import { hasOnboardingCompleted } from "./helpers/organization";
/*
window.Rewardful = {
  coupon: {
    id: "zZ7SdXIK",
  },
  ready: (fn) => {
    fn();
  },
};
*/
require("./helpers/confetti");

const RouterClass = (props) => {
  const { clearErrors, initializeIntercom, shutdownIntercom, updateIntercom } =
    useAppStore();
  const history = useHistory();
  const location = useLocation();
  const { user, checkSession, logout } = useUserStore();
  const { currentOrganization } = useCurrentOrganizationStore();
  const { autologin } = useAutologinStore();
  const { fetchAppTag } = useAppTagStore();

  if (!AxiosConfig._token && user.token) {
    AxiosConfig.setAuthToken(user.token);
  }

  // TODO this is to surpress the error message appearing in the web browser.
  // Assign a ticket to resolve this issue.
  useEffect(() => {
    window.addEventListener("error", (e) => {
      console.log(e);
      if (
        e.message ===
        "ResizeObserver loop completed with undelivered notifications."
      ) {
        const resizeObserverErrDiv = document.getElementById(
          "webpack-dev-server-client-overlay-div"
        );
        const resizeObserverErr = document.getElementById(
          "webpack-dev-server-client-overlay"
        );
        if (resizeObserverErr) {
          resizeObserverErr.setAttribute("style", "display: none");
        }
        if (resizeObserverErrDiv) {
          resizeObserverErrDiv.setAttribute("style", "display: none");
        }
      }
    });
  }, []);

  useEffect(() => {
    if (!user.model) {
      // redirect to login page if current location is not one of the following:
      // /login, /register, /password-reminder, /password-reset, /account-verification, /
    }
  }, []);

  useEffect(() => {
    if (user.token) {
      checkSession();
    }

    initializeIntercom(user, currentOrganization, true);
  }, []);

  useEffect(() => {
    if (autologin.loginSuccess && user.token) {
      fetchAppTag();
      shutdownIntercom();
    }
  }, [autologin.loginSuccess]);

  useEffect(() => {
    if (
      (user.loginSuccess || user.registerSuccess || user.checkSessionSuccess) &&
      !autologin.model
    ) {
      updateIntercom(user, currentOrganization, true);
    }
  }, [
    user.loginSuccess,
    user.registerSuccess,
    user.checkSessionSuccess,
    autologin.loginSuccess,
  ]);

  useEffect(() => {
    // session has expired
    if (user.sessionExpired) {
      logout();
      window.alert("Your session has expired. Please log in again.");
    }
  }, [user.sessionExpired]);

  useEffect(() => {
    if ((!user.model && user.loginSuccess && user.token) || autologin.logout) {
      if (autologin.logout) {
        clearErrors();
      }
      // fetchDomains();
      // fetchIntegrations();
    }
  }, [autologin.logout]);

  useDidMountEffect(() => {
    if (
      history.location.pathname !== "/verify-email" &&
      user.model &&
      !user.model.is_account_verified
    ) {
      // redirect to verify email page
      window.location.pathname = "/verify-email";
    } else if (
      history.location.pathname === "/verify-email" &&
      user.model?.is_account_verified
    ) {
      console.log("User is already verified, redirecting to onboarding");
      if (hasOnboardingCompleted(currentOrganization)) {
        history.push("/dashboard");
        return;
      }
      history.push("/onboarding");
    }
  }, [user.model, history, history.location.pathname]);

  useDidMountEffect(() => {
    if (
      user.token !== null &&
      !autologin.loginSuccess &&
      user.model.is_account_verified
    ) {
      // todo user's token refreshes every time check session is successful. No need to refresh these every time.

      fetchAppTag();
    }
  }, [user.token]);

  const modalLinks = [
    "/domains/:uuid",
    `/${appConfig.links.organization}/edit/:uuid`,
    "/manage-members",
    "/new-organization",
    "/install/:widgetType/:uuid",
  ];

  const orgEditModalLink = `/${appConfig.links.organization}/edit/:uuid`;
  const prevModalLocation = [
    {
      "/domains/:uuid": `/domains`,
    },
    {
      orgEditModalLink: `/${appConfig.links.organizations}`,
    },
    { "/manage-members": "/dashboard" },
    { "/new-organization": "/dashboard" },
    { "/install/:widgetType/:uuid": "/:widgetType/:uuid" },
  ];

  return (
    <BrowserRouter key={location.pathname}>
      <ReactNotifications />
      <OrgSwitchOverlay />
      <MainRoutesComponent
        user={user}
        modalLinks={modalLinks}
        location={location}
      />
      <ModalRoutesComponent
        user={user}
        modalLinks={modalLinks}
        prevModalLocation={prevModalLocation}
      />
      <GraceInfoModal />
    </BrowserRouter>
  );
};

export default RouterClass;
